import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import { MenuItem, Link } from '@mui/material';
import ExpandMoreIcon  from '@mui/icons-material/ExpandMore';
import classNames from 'classnames';

import PropTypes from 'prop-types';

export default function Dropdown(props) {
    const {
        placeholder,
        onChange,
        options,
        defaultValue,
        defaultId,
        error,
        helperText,
        name,
        isLink,
        variant,
        selectId,
    } = props;
    const [value, setValue] = useState(defaultValue || '');
    const [id, setId] = useState(defaultId);
    const [iconClass, setIconClass] = useState(null);

    useEffect(() => {
        if (defaultValue) {
            setValue(defaultValue);
        } else {
            setValue('');
        }
        setId(selectId);
    }, [defaultValue]);

    const handleChange = (event) => {
        setValue(event.target.value);
        if (onChange) {
            onChange(event.target.value, event);
        }
    };   

    const onDropdownOpen = () => {
        setIconClass('flip-icon');
    };

    const onDropdownClose = () => {
        setIconClass(null);
    };

    const renderLinkItem = (label, val) => {
        if (isLink) {
            return (
                <MenuItem key={label} value={val} className='dropdown-component-menu-item'>
                    <Link href={`#${val}`} to={`#${val}`} className='dropdown-component'>                        
                        <MenuItem key={label} value={val} className='dropdown-component-menu-item'>
                            {label}
                        </MenuItem>                        
                    </Link>
                </MenuItem>
            );
        }
        return (
            <MenuItem key={label} value={val}>
                {label}
            </MenuItem>
        );
    };

    return (
        <TextField  
            className='dropdown-component-textfield'                      
            id={id}  
            select          
            label={placeholder}            
            value={value}     
            onChange={handleChange}
            variant={variant || 'outlined'}
            color="secondary"
            name={name}
            error={error}
            helperText={helperText}           
            slotProps={{
                select: {  
                    // eslint-disable-next-line react/display-name
                    IconComponent: ({ className }) => (
                        <ExpandMoreIcon className={classNames(className, iconClass)} />
                    ),
                    MenuProps: {
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        }
                    },
                    onOpen: () => onDropdownOpen(),
                    onClose: () => onDropdownClose(),
                }
            }}
        >
            {options && options.length > 0 ? options.map((option) => renderLinkItem(option.label, option.value)) : <MenuItem disabled>Loading...</MenuItem>}
        </TextField>
    );
}

Dropdown.propTypes = {
    placeholder: PropTypes.string,
    options: PropTypes.array,
    defaultValue: PropTypes.string,
    defaultId: PropTypes.string,
    error: PropTypes.bool,
    helperText: PropTypes.string,
    name: PropTypes.string,
    isLink: PropTypes.bool,
    variant: PropTypes.string,
    selectId: PropTypes.string,
    className: PropTypes.object,

    onChange: PropTypes.func,
};

